import { registerComponentsMap } from '@namespace/auth';
import { Cities } from './Cities';
import { Regions } from './Regions';

export const FORM_COMPONENTS_TYPES = {
  REGIONS_SELECT: 'REGIONS_SELECT',
  CITIES_SELECT: 'CITIES_SELECT'
};

export const formComponentsMap = {
  ...registerComponentsMap,
  [FORM_COMPONENTS_TYPES.REGIONS_SELECT]: Regions,
  [FORM_COMPONENTS_TYPES.CITIES_SELECT]: Cities
};
